<template>
  <p class="editor-section-label">
    <slot>{{ text }}</slot>
  </p>
</template>

<script>
export default {
  name: 'EditorSectionLabel',
  props: {
    text: { type: String, default: '' }
  }
}
</script>

<style scoped>
.editor-section-label {
  font-size: var(--editor-font-size-label);
  color: var(--editor-color-label);
  text-align: left;
  margin: var(--editor-space-3) 0 var(--editor-space-1);
  font-weight: 400;
  white-space: pre-line;
}
</style>
